import React from "react";
import '../../App.css';


function Views() {
    return (
        <div className="views">
        <br/><br/><br/><br/><br/>
        <img src="../c1.JPG" alt="house" className="img"/>
        <h4>No! No! No! No! No! No! No! No! No! No! No!</h4>
     </div>
    )
}

export default Views;
